/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Debt_Bucket_90_PlusInputs */

const vi_report_debt_bucket_90_plus = /** @type {(inputs: Report_Debt_Bucket_90_PlusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trên 90 ngày`)
};

/**

* @param {Report_Debt_Bucket_90_PlusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_debt_bucket_90_plus = /** @type {((inputs?: Report_Debt_Bucket_90_PlusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Debt_Bucket_90_PlusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_debt_bucket_90_plus(inputs)
});